module.exports = __webpack_public_path__ + "img/222.6e634a2b.png";